import { ProductDeliveryPromiseExplanations } from './product-detail/ProductTypes';
import { ProductLister } from './product-lister';

export type ProductGroupById = {
  [key: string]: Array<ProductLister>;
};

export type ProductGroupProduct = {
  productCode: string;
  productColor: string;
};

export type ProductGroupProducts = {
  fallbackProducts: Array<ProductGroupProduct>;
  productCode: string;
  productColor: string;
};

export type ProductGroupOptions = {
  products: Array<ProductGroupProducts>;
  tileFormat: string;
  title?: string;
  deliveryPromiseExplanations?: ProductDeliveryPromiseExplanations;
  collapsed: boolean;
  collapsible: boolean;
};

export type ProductGroupAnalyticsData = {
  componentName: string;
  componentType: string;
  productTilePosition: number;
};
